"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfolioPage = void 0;
const erc20_service_1 = require("@app/services/erc20.service");
const nft_service_1 = require("@app/services/nft.service");
const button_1 = require("@components/button");
const error_notification_1 = require("@components/error-notification");
const grid_1 = require("@components/grid");
const icons_1 = require("@components/icons");
const loader_1 = require("@components/loader");
const text_input_1 = require("@components/text-input");
const total_assets_1 = require("@components/total-assets");
const useForm_1 = require("@hooks/useForm");
const useNotification_1 = require("@hooks/useNotification");
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const react_use_clipboard_1 = __importDefault(require("react-use-clipboard"));
const helper_1 = require("./helper");
require("./styles.scss");
const PortfolioPage = (props) => {
    const [userNft, setUserNft] = (0, react_1.useState)([]);
    const [tokensList, setTokensList] = (0, react_1.useState)([]);
    const [wallet, setWallet] = (0, react_1.useState)();
    const [totalAssets, setTotalAssets] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [activeTab, setActiveTab] = (0, react_1.useState)("portfolio");
    const [isCopied, setCopied] = (0, react_use_clipboard_1.default)(wallet || "");
    const { notificationMessage, notificationStatus, showNotification } = (0, useNotification_1.useNotification)();
    const [widthScale, setWidthScale] = (0, react_1.useState)(1);
    const { form, fieldHandlers, submit } = (0, useForm_1.useForm)({
        initialData: { wallet: "" },
        submit: (form) => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            setWallet(form.wallet);
            const { tokens, totalAssets } = yield erc20_service_1.erc20Service.getAllTokensBalance(form.wallet, showNotification);
            setTokensList(tokens);
            setTotalAssets(totalAssets);
            const object = yield nft_service_1.nftService.getNftByWallet(form.wallet);
            setUserNft(object);
            setIsLoading(false);
        }),
    });
    (0, react_1.useEffect)(() => {
        if (notificationStatus) {
            setIsLoading(false);
        }
    }, [notificationStatus]);
    (0, react_1.useEffect)(() => {
        if (window.innerWidth <= 575) {
            setWidthScale(0.6);
        }
        else if (576 <= window.innerWidth && window.innerWidth <= 1250) {
            setWidthScale(0.8);
        }
    }, [window.innerWidth]);
    const config = (0, react_1.useMemo)(() => (0, helper_1.getColumnConfig)(), [userNft]);
    const erc20Config = (0, react_1.useMemo)(() => (0, helper_1.getERC20ColumnConfig)(), [userNft]);
    return (React.createElement("div", { className: "p-profile-page" },
        React.createElement("div", { className: "p-profile-page__header" },
            React.createElement(text_input_1.TextInput, { placeholder: "Enter wallet", value: form.wallet, onChangeValue: fieldHandlers.wallet }),
            React.createElement("div", null,
                React.createElement(button_1.Button, { children: "Search", type: "primary", size: "small", onClick: submit, disabled: isLoading }))),
        wallet && (React.createElement("div", { className: "p-profile-page__body" },
            React.createElement("div", { className: "p-profile-page__user" },
                React.createElement("div", { className: "p-profile-page__avatar" },
                    React.createElement(icons_1.UserIcon, { scale: widthScale })),
                React.createElement("div", { className: "p-profile-page__info" },
                    React.createElement("div", { className: "p-profile-page__address" },
                        React.createElement("p", { onClick: () => window.navigator.clipboard.writeText(wallet) }, wallet),
                        React.createElement("div", { className: "p-profile-page__copy-btn", onClick: setCopied },
                            React.createElement(icons_1.CopyIcon, { scale: widthScale }))),
                    React.createElement("div", { className: "p-profile-page__tabs-list" },
                        React.createElement("div", { className: (0, classnames_1.default)("p-profile-page__tab", {
                                "p-profile-page__tab-active": activeTab === "portfolio",
                            }), onClick: () => setActiveTab("portfolio") }, "Portfolio"),
                        React.createElement("div", { className: (0, classnames_1.default)("p-profile-page__tab", { "p-profile-page__tab-active": activeTab === "nft" }), onClick: () => setActiveTab("nft") }, "NFT")))),
            React.createElement("div", { className: "p-profile-page__content" }, isLoading ? (React.createElement(loader_1.Loader, null)) : activeTab === "portfolio" ? (tokensList[0] && totalAssets ? (React.createElement("div", { className: "p-profile-page__content-wrapper" },
                React.createElement(total_assets_1.TotalAssets, { totalAssets: totalAssets }),
                React.createElement(grid_1.Grid, { data: tokensList, onPageChange: () => console.log("ok"), getKey: ({}) => crypto.randomUUID(), columns: erc20Config, pageSize: 1, totalSize: 1 }))) : (React.createElement("div", { className: "p-profile-page__no-items" }, "No tokens"))) : userNft[0] ? (React.createElement(grid_1.Grid, { data: userNft, onPageChange: () => console.log("ok"), getKey: ({}) => crypto.randomUUID(), columns: config, pageSize: 1, totalSize: 1 })) : (React.createElement("div", { className: "p-profile-page__no-items" }, "No collections"))))),
        notificationStatus && React.createElement(error_notification_1.ErrorNotification, null, notificationMessage)));
};
exports.PortfolioPage = PortfolioPage;
